var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 41,
    viewBox: "0 0 18 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79095 7.01044L9.3623 1.82746L5.13764 1L1 4.39718L3.3083 39.4578L16.897 39.5449L17.0277 36.0606L15.6775 35.3202L14.85 33.8829L16.5921 32.8376L16.5486 30.7035L13.3256 30.1809L11.4093 28.3952L10.9737 24.606L9.84133 22.9074L9.27513 16.8535L7.40233 16.2873L6.35705 13.0208L5.44242 13.3692L4.87625 11.6706L6.00864 10.6253L5.79095 7.01044Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.7cda3d5ed45de0ad5b491eeeb691beb7.svg";
export { ForwardRef as ReactComponent };